import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import { getNewMovies } from '@/mocks/movies';
import { categories } from '@/mocks/categories';

export default function LatestSection() {
  const newMovies = getNewMovies().slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新更新
            </h2>
            <p className="text-foreground-500 text-sm">每日更新热门影视资源，精彩不容错过</p>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            {categories.slice(0, 4).map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-3 py-1.5 rounded-full text-xs font-medium bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5" data-product-shop>
          {newMovies.map(movie => (
            <MovieCard key={movie.id} movie={movie} variant="compact" />
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-primary-300 text-primary-600 hover:bg-primary-50 font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            加载更多内容
            <i className="ri-arrow-down-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}